@if (!meteoInfosReport) {
  <ion-row class="sis-center">
    <ion-col>
      <ion-spinner></ion-spinner>
    </ion-col>
  </ion-row>
}

@if (meteoInfosReport.size > 0) {
  @for (tenant of meteoInfosReport | keyvalue; track trackByTenantKey($index, tenant)) {
    <sis-webreport-meteo-mobile-item
      [meteoInfos$]="meteoInfos$"
      [mobileStyleTenant]="mobileStyleTenant"
      [config]="config"
      [tenantAlias]="tenant.key"
      [activeSeasonByTenantAlias]="activeSeasonByTenantAlias"
    ></sis-webreport-meteo-mobile-item>
  }
}
